import React, { useState, useEffect } from "react";

import { Popup } from "components/UI/Popup";
import { PrefOption } from "./PrefOption";
import { FORM_FIELDS } from "./constants";
import { useVisitorInfo } from "hooks/useVisitorInfo";
import { apiVisitor } from "services";
import "./style/PreferencesPopup.scss";

export const PreferencesPopup = () => {
  const [showPopup, setShowPopup] = useState<boolean|undefined>(undefined);
  const [isSendingData, setSendingData] = useState(false);
  const [prefOptions, setPrefOptions] = useState(FORM_FIELDS);
  const visitorInfo = useVisitorInfo();

  useEffect(() => {
    console.debug("Visitor info changes, checking for preferences.");

    if (visitorInfo && !visitorInfo?.preferences?.length && showPopup === undefined) {
      console.debug("Showing the preferences dialog.");
      setShowPopup(true);
    }
  }, [visitorInfo, showPopup]);

  const handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const targetName = event.target.name;
    const copyOptions = [...prefOptions];

    for (const filed of copyOptions) {
      if (filed.name === targetName) {
        filed.isChecked = !filed.isChecked;
      }
    }

    setPrefOptions([...copyOptions]);
  };

  const canSend = (): boolean => {
    const selected = prefOptions.filter((x) => x.isChecked);
    return !isSendingData && selected.length > 0; // isSendingData
  };

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    setSendingData(true);

    const filterCheckedPrefs = prefOptions.filter(({ isChecked }) => isChecked);
    const prefValues = filterCheckedPrefs.length ?
      filterCheckedPrefs.map(({ value }) => value) : [];

    const dataToSend = [
      {
        path: "/preferences",
        value: prefValues
      }
    ];

    try {
      await apiVisitor.updateVisitorInfo(dataToSend);
    } catch (err) {
      console.error("Error saving preferences.");
    } finally {
      console.debug("Closing the preferences popup.");
      setSendingData(false);
      setShowPopup(false);
    }
  };

  const renderForm = () => {
    return (
      <form className="PopupPreferences-Form" onSubmit={handleSubmit}>
        {prefOptions.map((filed, index) => (
          <PrefOption key={index} handleCheckbox={handleCheckBoxChange} {...filed} />
        ))}

        <button
          type="submit"
          className="Button-Submit"
          disabled={!canSend()}
        >{isSendingData ? "Sending..." : "Save"}</button>
      </form>
    );
  };

  return (
    <Popup
      title="Define Your Preferences"
      isOpen={!!showPopup}
      className="PopupPreferences"
    >
      <div className="PopupPreferences-Cnt">
        <p className="PopupPreferences-Description">Customize your RedGIFs experience by selecting what you'd like to see:</p>
        {renderForm()}
      </div>
    </Popup>
  );
};
